// /!\ IF YOU MODIFY THIS FILE, THEN DON'T FORGET TO UPDATE THE BACKEND AT :
// le-coin-du-prof-back/coin_du_prof/backend/utils/file_validators.py

export const acceptedFileTypes = {
	'pdf': {
		extensions: ['pdf'],
		logo: '/img/file-types/pdf.svg',
		name: 'PDF'
	},
	'document': {
		extensions: ['doc', 'docx', 'odt'],
		logo: '/img/file-types/word.svg',
		name: 'Document Word'
	},
	'spreadsheet': {
		extensions: ['xls', 'xlsx', 'csv', 'ods'],
		logo: '/img/file-types/excel.svg',
		name: 'Tableur'
	},
	'presentation': {
		extensions: ['ppt', 'pptx', 'odp'],
		logo: '/img/file-types/powerpoint.svg',
		name: 'Présentation'
	},
	'image': {
		extensions: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'odg'],
		logo: '/img/file-types/image.svg',
		name: 'Image'
	},
	'video': {
		extensions: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'],
		logo: '/img/file-types/video.svg',
		name: 'Vidéo'
	},
	'audio': {
		extensions: ['mp3', 'wav', 'ogg', 'aac', 'flac'],
		logo: '/img/file-types/audio.svg',
		name: 'Audio'
	},
	'archive': {
		extensions: ['zip', 'rar', '7z', 'tar', 'gz'],
		logo: '/img/file-types/archive.svg',
		name: 'Archive'
	},
	'text': {
		extensions: ['txt', 'rtf', 'md'],
		logo: '/img/file-types/text.svg',
		name: 'Texte'
	},
	'code': {
		extensions: ['html', 'css', 'js', 'php', 'py', 'java', 'cpp', 'c', 'json', 'xml'],
		logo: '/img/file-types/code.svg',
		name: 'Code'
	},
	'default': {
		extensions: ['tex','ggb','fls'],
		logo: '/img/file-types/file.svg',
		name: 'Fichier'
	}
}

export const previewableFileTypes = [
	acceptedFileTypes['pdf'],
	acceptedFileTypes['document']
]

export function getFileExtension(filename) {
	if (!filename) return ''
	const parts = filename.split('.')
	return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ''
}

export function getFileTypeInfo(filename) {
	const extension = getFileExtension(filename)
	
	for (const [type, info] of Object.entries(acceptedFileTypes)) {
		if (type === 'default') continue
		if (info.extensions.includes(extension)) {
			return info
		}
	}
	return acceptedFileTypes.default
}

export function getFileLogo(filename) {
	return getFileTypeInfo(filename).logo
}

export function getFileTypeName(filename) {
	return getFileTypeInfo(filename).name
}

export function isFileAccepted(filename) {
	const extension = getFileExtension(filename)
	return Object.values(acceptedFileTypes).some(type => 
		type.extensions.includes(extension)
	)
}

export function getAllAcceptedExtensions() {
	const extensions = []
	Object.values(acceptedFileTypes).forEach(type => {
		extensions.push(...type.extensions)
	})
	return extensions
}

export function getMaxFileSize() {
	return 50 * 1024 * 1024 // 50MB
}

export function isFileSizeValid(fileSize) {
	return fileSize <= getMaxFileSize()
}

export function canPreviewFile(filename) {
	const fileTypeInfo = getFileTypeInfo(filename)
	return previewableFileTypes.filter(
		type => type.name.toLowerCase() === fileTypeInfo.name.toLowerCase()
	).length > 0
} 